module.exports = __webpack_public_path__ + "static/media/Wound-Risk.e02e05f6.png";